export const categories = {
  title: 'الفئات',
  description: 'إدارة فئات المنتجات',
  form: {
    createTitle: 'فئة جديدة',
    editTitle: 'تعديل الفئة',
    fields: {
      name: 'الاسم',
      description: 'الوصف',
      type: 'النوع',
      parent: 'الفئة الأم',
      isActive: 'نشط',
      image: 'الصورة'
    },
    placeholders: {
      name: 'أدخل اسم الفئة',
      description: 'أدخل وصف الفئة',
      parent: 'اختر الفئة الأم',
      image: 'اختر صورة'
    },
    validations: {
      required: 'هذا الحقل مطلوب',
      minLength: 'يجب أن يحتوي هذا الحقل على {min} أحرف على الأقل',
      maxLength: 'يجب ألا يتجاوز هذا الحقل {max} حرف'
    },
    create: 'إنشاء',
    update: 'تحديث',
    cancel: 'إلغاء',
    submitting: 'جاري الحفظ...'
  },
  columns: {
    name: 'الاسم',
    description: 'الوصف',
    type: 'النوع',
    parent: 'الفئة الأم',
    isActive: 'الحالة',
    image: 'الصورة',
    basicInfo: 'المعلومات الأساسية',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'تاريخ التحديث',
    lastSync: 'آخر مزامنة'
  },
  filters: {
    search: {
      label: 'بحث',
      placeholder: 'البحث عن فئة...'
    },
    type: {
      label: 'النوع',
      product: 'منتج',
      service: 'خدمة'
    },
    status: {
      label: 'الحالة',
      active: 'نشط',
      inactive: 'غير نشط'
    }
  },
  actions: {
    newCategory: 'فئة جديدة',
    edit: 'تعديل',
    delete: 'حذف',
    view: 'عرض'
  },
  confirmations: {
    delete: 'هل أنت متأكد من حذف هذه الفئة؟',
    deleteSuccess: 'تم حذف الفئة بنجاح',
    createSuccess: 'تم إنشاء الفئة بنجاح',
    updateSuccess: 'تم تحديث الفئة بنجاح'
  },
  errors: {
    load: 'خطأ في تحميل الفئات',
    create: 'خطأ في إنشاء الفئة',
    update: 'خطأ في تحديث الفئة',
    delete: 'خطأ في حذف الفئة',
    cannotDeleteWithProducts: "لا يمكن حذف الفئة لأنها تحتوي على منتجات",
    deleteError: "خطأ في حذف الفئة"
  },
  pagination: {
    totalItems: 'إجمالي العناصر',
    previous: 'السابق',
    next: 'التالي',
    page: 'الصفحة',
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    items: 'عناصر'
  }
}; 